// Declare variables injected by Webpack

/* eslint-disable @typescript-eslint/naming-convention */
declare const ENVIRONMENT__RAILS_URL: string;
declare const ENVIRONMENT__MACHINE_CLOUD_CLIENT_URL: string;
declare const ENVIRONMENT__MACHINE_CLOUD_API_URL: string;
declare const ENVIRONMENT__IS_TESTING_REMOTE_SUPPORT: boolean;
declare const ENVIRONMENT__REMOTE_EXEC_ENGINE: undefined | { port: string, token: string };
declare const ENVIRONMENT__CI_RUN: boolean;
declare const ENVIRONMENT__PYTHON_DOCUMENTATION_URL: string;
/* eslint-enable @typescript-eslint/naming-convention */

// Export variables injected by Webpack
export const EnvironmentVariables = {
  RAILS_URL: ENVIRONMENT__RAILS_URL,
  MACHINE_CLOUD_CLIENT_URL: ENVIRONMENT__MACHINE_CLOUD_CLIENT_URL,
  MACHINE_CLOUD_API_URL: ENVIRONMENT__MACHINE_CLOUD_API_URL,
  IS_TESTING_REMOTE_SUPPORT: ENVIRONMENT__IS_TESTING_REMOTE_SUPPORT,
  REMOTE_EXEC_ENGINE: ENVIRONMENT__REMOTE_EXEC_ENGINE,
  CI_RUN: ENVIRONMENT__CI_RUN,
  PYTHON_DOCUMENTATION_URL: ENVIRONMENT__PYTHON_DOCUMENTATION_URL,
};
